import * as qs from 'qs';

export const buildQueryString = (params: qs.ParsedQs) => qs.stringify(params);

export const parseUrl = (url: string) => {
  const [pathWithQueryString, hash] = url.split('#');
  const [path, queryString] = pathWithQueryString.split('?');
  return {
    path,
    hash,
    queryParams: qs.parse(queryString),
  };
};

export const parseQueryString = (queryString: string) => qs.parse(queryString);

export const buildUrl = (url: string, params?: qs.ParsedQs, hash?: string) => {
  const queryKeys = params ? Object.keys(params) : [];
  if (queryKeys.length === 0) {
    return url;
  }

  return `${url}${hash ?? ''}?${buildQueryString(params ?? {})}`;
};

export const setUrlQueryString = (url: string, key: string, value: string) => {
  const [path, paramString] = url.split('?');
  const newParams = new URLSearchParams(paramString);
  newParams.set(key, value);
  return `${path}?${newParams.toString()}`;
};

// TODO buildUrl와 통합 필요
export const generateUrl = (url: string, params: Record<string, any>, hash?: string) => {
  const query = params
    ? `?${new URLSearchParams(
        Object.keys(params)
          .filter(k => !!params[k])
          .reduce((a, k) => ({ ...a, [k]: params[k] }), {}),
      )}`
    : '';
  return `${url}${hash || ''}${query.toString()}`;
};

export const getPaginatorParam = (page: number, rowPerPage: number) => ({
  offset: page * rowPerPage,
  limit: rowPerPage,
});
